import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid, TextField } from '@mui/material';
import * as CONST from '../../../../constants/FieldsConst';
import Box from '@mui/material/Box';
import { saveCarrerasAction } from '../CarrerasAction';
import { validMessage } from '../../../../constants/ValidsFormConst';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { LoadingWidget } from '../../../../widgets';
import { useNotification } from '../../../../helpers/Notification';
import { soloNumero } from '../../../../helpers';

const FormCarreras = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const carrerasStore = Redux.useSelector((state) => state.carreras);

  const activo = carrerasStore.activo;

  const initData = {
    nombre: '',
    numero: 1,
    codigo: '',
    link: '',
    desc: '',
    idEstatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    nombre: false,
    numero: false,
    codigo: false,
    link: false,
    desc: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(
      () =>
        setData({
          ...values,
          idEstatus: activo.estatus?.id ?? 1,
        }),
      300,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await saveCarrerasAction(
        { dispatch, notify },
        activo?.id,
        data,
        carrerasStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            size="small"
            id={CONST.codigo.name}
            required
            label={CONST.codigo.label}
            value={data.codigo}
            onChange={(e) =>
              _handleSetDataField(CONST.codigo.name, e.target.value)
            }
            helperText={dataError.codigo ? validMessage.required : null}
            error={dataError.codigo}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            size="small"
            id={CONST.nombre.name}
            required
            label={CONST.nombre.label}
            value={data.nombre}
            onChange={(e) =>
              _handleSetDataField(
                CONST.nombre.name,
                e.target.value.toUpperCase(),
              )
            }
            helperText={dataError.nombre ? validMessage.required : null}
            error={dataError.nombre}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            size="small"
            id={CONST.numero.name}
            required
            label={CONST.numero.label}
            value={data.numero}
            type="number"
            onChange={(e) =>
              _handleSetDataField(CONST.numero.name, soloNumero(e.target.value))
            }
            helperText={dataError.numero ? validMessage.required : null}
            error={dataError.numero}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.link.name}
            required
            label={CONST.link.label}
            value={data.link}
            onChange={(e) =>
              _handleSetDataField(CONST.link.name, e.target.value)
            }
            helperText={dataError.link ? validMessage.required : null}
            error={dataError.link}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.desc.name}
            required
            label={CONST.desc.label}
            value={data.desc}
            multiline
            rows={4}
            onChange={(e) =>
              _handleSetDataField(CONST.desc.name, e.target.value)
            }
            helperText={dataError.desc ? validMessage.required : null}
            error={dataError.desc}
          />
        </Grid>
        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormCarreras;
